import { ItiBaseDto } from '@/iti-core-vue';

export class Rol extends ItiBaseDto {
    public name!: string;
    public description!: string;
    public normalizedName!: string;
}
